import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Get, Patch } from "../Axios/AxiosFunctions";
import { URL } from "../Config/apiUrl";
import { useSelector } from "react-redux";
import CoverPhotoCompo from "./CoverPhotoCompo";

const EditProfileModal = ({
  handleClose,
  show,
  setSummaryEdit,
  profileData,
  setFlagCheck
}) => {
  const Id = useSelector((state) => state?.authReducer?.user?._id);
//   console.log({profileData})
  const [state, setstate] = useState({
    summary:profileData?.description,
    address:profileData?.address,
    email:profileData?.email,
    contactNo:profileData?.contactNo,
  })

  const [test, setTest] = useState(profileData?.address);
//   const [test, setTest] = useState(profileData?.address);
  const handleChange = (e) => {
    
    const {name , value } = e.target
    setstate({...state,[name]:value})
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = { description: state.summary ,contactNo:state.contactNo,email:state.email,address:state.address };

    const response = await Patch(updateUpperSection,data);
    console.log(response.status);
    if(response.status == 200){
        const flag = Math.random()
    console.log(flag)
    setFlagCheck(flag)
    }

  };

  const updateUpperSection = URL(`craftman/updateCraftman/${Id}`);
  const [coverImage, setImages] = React.useState([]);
  const maxNumber = 69;

  const onChange1 = (imageList, addUpdateIndex) => {
      console.log(imageList)
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  console.log()
  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="text-center">Edit Data</Modal.Title>
          </Modal.Header>
          <>
          <h4 className="text-center"> Cover Photo</h4>
          <div className="App mb-4">
     <CoverPhotoCompo coverImage={coverImage} onChange1={onChange1} maxNumber={maxNumber} />
    </div>

            <div className="text-center  mb-4">

            <h4>Summary</h4>
            <textarea
            
            name="summary"
            value={state.summary}
            onChange={handleChange}>
            </textarea>
            </div>
            <div className="text-center  mb-4">

            <h4>Location</h4>
            <input
            name="address"
            value={state.address}
            onChange={handleChange}
            ></input>
        </div>
        <div className="text-center  mb-4">

            <h4>Phone Number</h4>
            <input
              name="contactNo"
              value={state.contactNo}
              onChange={handleChange}
            ></input>
            </div>
         
          </>
          <Modal.Footer className="d-flex j-center">
            <Button  onClick={handleClose}>
              Close
            </Button>
            <Button  type="submit" onClick={handleClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default EditProfileModal;
